/** 平台 catalog 拉取状态 */
export type PlatformCatalogLoadSnapshot = {
  loading: boolean
  remoteSynced: boolean
  error: string | null
}

export function isPlatformCatalogLoadPending({
  loading,
  remoteSynced,
  error,
}: PlatformCatalogLoadSnapshot): boolean {
  if (remoteSynced) return false
  if (loading) return true
  if (error) return false
  return true
}

export function isPlatformCatalogLoadFailed({
  loading,
  remoteSynced,
  error,
}: PlatformCatalogLoadSnapshot): boolean {
  return !loading && !remoteSynced && error != null
}
